import { useEffect } from "react";

/**
 * Si no hay usuario después de un breve delay, solicita el usuario a la app principal (parent frame)
 * @param {{ getUserCookie: () => any }} params
 */
export default function useRequestUserFromParent({ getUserCookie }) {
  useEffect(() => {
    // Si no hay usuario tras 500ms, pide el usuario a la app principal
    const timer = setTimeout(() => {
      try {
        const cookie = getUserCookie();
        if (!cookie && window.parent !== window) {
          window.parent.postMessage({ type: "REQUEST_USER" }, "*");
        }
      } catch (_) {
        // ignore
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [getUserCookie]);
}
